import { ReactNode } from 'react';
import './Layout.css';

interface LayoutProps {
  leftRail: ReactNode;
  map: ReactNode;
}

export default function Layout({ leftRail, map }: LayoutProps) {
  return (
    <div className="layout">
      <aside className="layout-rail">{leftRail}</aside>
      <main className="layout-map">{map}</main>
    </div>
  );
}

